/* =========================================================
	MAIN JS FILE
	For site-wide scripts

	01. Alpine.js
	02. AOS (animate on scroll)
	03. Show/hide header based on scroll position
========================================================= */

/* 01. Alpine.js ---------------- */
import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start()

/* 02. AOS (animate on scroll) ---------------- */
import AOS from 'aos';
AOS.init({
	duration: 1000
});

/* 03. Show/hide header based on scroll position ---------------- */
const header = document.querySelector("header.nav");
let lastScroll = 0;

const throttle = (func, time = 100) => {
	let lastTime = 0;
	return () => {
		const now = new Date();
		if (now - lastTime >= time) {
			func();
			time = now;
		}
	};
};

const validateHeader = () => {
	const windowY = window.scrollY;
	const windowH = window.innerHeight * 0.25;

	if (windowY > windowH) {
		// We passed the first section, set a toggable class
		header.classList.add("is-fixed");

		// Determine is we ready to animate
		if (windowY > windowH + 40) {
			header.classList.add("can-animate");
      if (windowY < lastScroll) {
			// Determine if we scrolling up
			header.classList.add("scroll-up");
		} else {
			header.classList.remove("scroll-up");
		}
	} else {
      header.classList.remove("scroll-up");
	}
	} else {
		header.classList.remove("is-fixed", "can-animate");
	}

  lastScroll = windowY;
};

window.addEventListener("scroll", throttle(validateHeader, 100));
